export default __webpack_public_path__ + "1be79e1238549b27eb15da19a63387cb.png";